import FormItem from "../../components/ui/FormItem";
import FormGrid from "../../components/ui/FormGrid";
import FormActions from "../ui/FormActions";
import Dropdown from "../common/dropdown/Dropdown";
import FileUpload from "../common/fileupload/FileUpload";
import Input from "../../components/ui/Input";
import Calendar from "../common/calendar/Calendar";

import BudgetInput from "./BudgetInput";

import { PROPERTY_TYPES, UNIT_TYPES } from "../../data/intialData";
import { formatDateDDMMYYYY, parseDateString } from "../../hooks/commonHooks";
import { usePropertyForm } from "./usePropertyForm";

const ALL_UNIT_TYPES_OPTION = "all";
const UNIT_TYPE_OPTIONS = [ALL_UNIT_TYPES_OPTION, ...UNIT_TYPES];
export default function PropertyForm({
  initialData = {},
  onSubmit,
  isLoading,
  onCancel,
}) {
  const {
    formData,
    minBudgetUnitType,
    maxBudgetUnitType,
    setMinBudgetUnitType,
    setMaxBudgetUnitType,
    errors,
    showCalendar,
    setShowCalendar,
    handleChange,
    handleFileChange,
    handleSubmit,
    handleCancel,
    isEditMode,
  } = usePropertyForm(
   initialData,
   onSubmit,
   onCancel
  );


  return (
    <section className="property-form position-relative">
      <form onSubmit={handleSubmit}>
        <FormGrid>
          <FormItem
            label="Property Name"
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
            error={errors.name}
            required
          />

        <FormItem
          label="City"
          value={formData.city}
          onChange={(e) => handleChange("city", e.target.value)}
          error={errors.city}
          required
        />

        <FormItem
          label="Area"
          value={formData.area}
          onChange={(e) => handleChange("area", e.target.value)}
          error={errors.area}
          required
        />

        <FormItem
          label="State"
          value={formData.state}
          onChange={(e) => handleChange("state", e.target.value)}
          error={errors.state}
          required
        />

        <FormItem
          label="Country"
          value={formData.country}
          onChange={(e) => handleChange("country", e.target.value)}
          error={errors.country}
          required
        />

        <FormItem
          label="Pincode"
          value={formData.pincode}
          onChange={(e) => handleChange("pincode", e.target.value)}
          error={errors.pincode}
          required
        />

        <FormItem label="Property Type" error={errors.property_type} required>
          <Dropdown
            options={PROPERTY_TYPES}
            value={formData.property_type}
            onChange={(value) => handleChange("property_type", value)}
          />
        </FormItem>

        <FormItem label="Site Property URL">
          <Input
          className="form-input"
            value={formData.site_property_url}
            error={errors.site_property_url}
            onChange={(e) =>
              handleChange("site_property_url", e.target.value)
            }
          />
        </FormItem>

        <FormItem label="Development Status" required>
          <Dropdown
            options={["ongoing", "completed", "upcoming"]}
            value={formData.possession_status}
            onChange={(value) =>
              handleChange("possession_status", value)
            }
          />
        </FormItem>

        <FormItem label="Unit Type" error={errors.unit_type} required>
          <Dropdown
            options={UNIT_TYPE_OPTIONS}
            multiple
            disabled={formData.property_type === "plot"}
            value={formData.unit_type}
            onChange={(value) => handleChange("unit_type", value)}
            shouldCloseOnSelect={(option) => option === ALL_UNIT_TYPES_OPTION}
          />
        </FormItem>

        <BudgetInput
          label="Min Budget"
          value={formData.min_budget}
          unit={minBudgetUnitType}
          onValueChange={(value) => handleChange("min_budget", value)}
          onUnitChange={(value) => setMinBudgetUnitType(value)}
          error={errors.min_budget_unit || errors.min_budget}
          required
        />
        <BudgetInput
          label="Max Budget"
          value={formData.max_budget}
          unit={maxBudgetUnitType}
          onValueChange={(value) => handleChange("max_budget", value)}
          onUnitChange={(value) => setMaxBudgetUnitType(value)}
          error={errors.max_budget_unit || errors.max_budget}
          required
        />
        <FormItem
          label="Expected Delivery"
          className="position-relative"
          error={errors.expected_delivery}
          required
        >
          <div className="form-input text-left" onClick={() => setShowCalendar(true)}>
            {formData.expected_delivery
              ? formatDateDDMMYYYY(formData.expected_delivery)
              : "Select date"}
          </div>
          {showCalendar && (
            <div className="calendar-popover">
              <Calendar
                value={
                  parseDateString(formData.expected_delivery) ?? undefined
                }
                onChange={(date) => {
                  handleChange("expected_delivery", date);
                  setShowCalendar(false);
                }}
              />
            </div>
          )}
                  </FormItem>

        <FormItem label="Brochure (PDF)" error={errors.brochure}>
          <FileUpload
            name="brochure"
            value={formData.brochure}
            onChange={(e) =>
              handleFileChange("brochure", e.target.files[0])
            }
          />
        </FormItem>

        <FormItem label="Image" error={errors.image} required>
          <FileUpload
            name="image"
            value={formData.image}
            onChange={(e) =>
              handleFileChange("image", e.target.files[0])
            }
          />
        </FormItem>
      </FormGrid>
      <FormActions
        isLoading={isLoading}
        loadingText={isEditMode ? "Updating..." : "Creating..."}
        saveText={isEditMode ? "Update Property" : "Create Property"}
        onCancel={handleCancel}
      />
    </form>

    </section>

  );
}